import Skills from './Skills';
import './Skills.scss';

export default Skills;
